/**
 * @file ReportList.jsx
 * @author Archana
 * @date 2024-10-24
 * @description Show the list of candidates
 */
import React from "react";
import {
  Box,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import dayjs from "dayjs";

export const ReportList = ({ isLoading, reportData }) => {
  return (
    <>
      <Box
        sx={{
          width: "100%",
          overflowX: "auto",
          "&::-webkit-scrollbar": { display: "none" },
          pb: 1,
        }}
      >
        {isLoading ? (
          <Skeleton
            variant="rounded"
            sx={{ mt: 2 }}
            width="100%"
            height={400}
          />
        ) : (
          <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow
                  sx={{
                    bgcolor: "#3A80F7",
                  }}
                >
                  <TableCell sx={{ color: "white", borderTopLeftRadius: 8 }}>
                    Name
                  </TableCell>
                  <TableCell sx={{ color: "white" }}>Email</TableCell>
                  <TableCell sx={{ color: "white" }}>
                    Lead Conversion Date
                  </TableCell>
                  <TableCell sx={{ color: "white" }}>Enquiry Date</TableCell>
                  <TableCell sx={{ color: "white" }}>Agent Name</TableCell>
                  <TableCell sx={{ color: "white" }}>Country Name</TableCell>
                  <TableCell
                    sx={{ color: "white", borderTopRightRadius: 8 }}
                    align="right"
                  >
                    Course Name
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reportData?.length > 0 ? (
                  reportData.map((data) => (
                    <TableRow key={data.candidateuuid}>
                      <TableCell>{data.name}</TableCell>
                      <TableCell>{data.email}</TableCell>
                      <TableCell>
                        {data?.leadconversiondate
                          ? dayjs(data.leadconversiondate).format("LL")
                          : ""}
                      </TableCell>
                      <TableCell>
                        {data?.enquirydate
                          ? dayjs(data.enquirydate).format("LL")
                          : ""}
                      </TableCell>
                      <TableCell>
                        {data.agentname ? data.agentname : "NA"}
                      </TableCell>
                      <TableCell>{data.countryname}</TableCell>
                      <TableCell align="right">{data.coursename}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      No report found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </>
  );
};
